<template>
  <el-dialog
    left
    title="Investment"
    :closeOnClickModal="false"
    :closeOnPressEscape="false"
    :showClose="true"
    :visible.sync="isShow"
    width="516px"
    style="margin: 0 auto;"
    class="diligence-dialog col-lg-12 col-sm-12 col-12 col-md-12"
    @close="cancelConvert()"
  >
    <div v-if="!isSuccess">
      <div
        style="font-size: 16px;margin-bottom: 21px;white-space: normal;word-break: normal;"
        v-if="value.data && value.data.portfolio && value.data.portfolio.name"
      >How much money would you like to invest in {{value.data.portfolio.name}}?</div>
      <form @submit.prevent="convertDiligence()">
        <div class="row" v-if="value.data && value.data.portfolio">
          <div class="col-12">
            <div>Investment (in $)</div>
            <input
              v-model="value.data.portfolio.cost"
              class="form-control team-form"
              placeholder="Investment"
              type="number"
              required
            />
          </div>
        </div>
        <div class="row">
          <div class="col-8" v-if="value.data && value.data.portfolio">
            <div>Date Of Investment</div>
            <input
              type="date"
              class="form-control team-form"
              style="width: 100%;"
              :max="moment().format('YYYY-MM-DD')"
              min="2000-01-01"
              :value="value.data.portfolio.initial_investment && moment.utc(value.data.portfolio.initial_investment).format('YYYY-MM-DD')"
              @input="value.data.portfolio.initial_investment = moment($event.target.valueAsDate)"
              placeholder="Current Cost"
            />
          </div>
        </div>
        <div slot="footer" class="dialog-footer" style>
          <div style="border: 0.8px solid #EDEDED;opacity: 1;margin-top: 18px;"></div>
          <div class="col-xl edit-company-action-button-row" style="padding: 0px;margin-top: 30px;">
            <button
              type="button"
              class="todo-form-cancel-button btn-outline-secondary"
              @click="cancelConvert"
            >Cancel</button>
            <button
              type="submit"
              class="todo-form-submit-button btn btn-primary"
              :disabled="isSaving"
            >
              Save
              <b-spinner v-if="isSaving" style="float: right;" small label="Loading..."></b-spinner>
            </button>
          </div>
        </div>
      </form>
    </div>
    <div v-else>
      <div
        style="font-size: 16px;margin-bottom: 21px;"
        v-if="value.data && value.data.portfolio && value.data.portfolio.name"
      >Success: Your investment has been saved</div>
      <div
        style="font-size: 16px;margin-bottom: 95px;"
        v-if="value.data && value.data.portfolio && value.data.portfolio.name"
      >
        To view the performance of this company go to
        <a
          class="navigateToPortfolio"
          @click="navigateToPortfolio"
        >Portfolio</a>
      </div>
      <div slot="footer" class="dialog-footer" style>
        <div style="border: 0.8px solid #EDEDED;opacity: 1;margin-top: 18px;"></div>
        <div class="col-xl edit-company-action-button-row" style="padding: 0px;margin-top: 30px;">
          <button
            type="submit"
            @click="value.isShow=false;isSuccess = false"
            class="todo-form-submit-button btn btn-primary"
          >Done</button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import config from "../../../../config/settings";
import { Dialog } from "element-ui";
import api from "../../../axios_api";
import moment from "moment";
export default {
  components: {
    [Dialog.name]: Dialog,
  },
  props: {
    value: {
      isShow: Boolean,
      data: Object,
    },
  },
  computed: {
    config(){
      return config;
    },
    moment() {
      return moment;
    },
    isShow: {
      get() {
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
      },
    },
  },
  data() {
    return {
      isSaving: false,
      isSuccess: false,
    };
  },
  methods: {
    navigateToPortfolio(){
      if(this.$route.params.ucid){
        this.value.isShow = false;
        this.isSuccess = false
        return;
      }
      this.$router.push(
              `/${this.$route.params.account_id}/${this.$route.params.workspace_id}/companyProfile/${this.value.data.portfolio.ucid}`
            );
      return;
    },
    cancelConvert() {
      this.$emit("cancel-refresh", {});
      this.value.isShow = false;
      this.isSuccess = false;
      this.value.data.portfolio.cost = "";
    },
    convertDiligence() {
      let self = this;
      self.isSaving = true;

      let existingPortfolioInfo = self.$store.getters[
        "portfolio/portfolioAll"
      ].find((item) => item._id == self.value.data.portfolio.portfolio_item);
      if (existingPortfolioInfo.amount)
        self.value.data.portfolio.cost =
          parseInt(existingPortfolioInfo.amount) +
          self.value.data.portfolio.cost;
      self.$store
        .dispatch("diligence/apiPatchPortfolioInfo", self.value.data.portfolio)
        .then((data) => {
          self.$store.dispatch("portfolio/_apiFetchPortfolio");
          self.isSaving = false;
          let attributorPayload = {
            diligence_id: self.value.data.portfolio._id,
            portfolio_item: self.value.data.portfolio.portfolio_item,
          };
          api
            .patch("/update/attributor/diligence", {
              encrypt: { data: attributorPayload },
            })
            .then((data) => {
              self.$store.dispatch("referrer/start");
            })
            .catch((err) => {
              console.log("Fail to update attributors entiity", { err });
            });
          // let payload = {
          //   diligenceId: self.value.data.portfolio._id,
          //   portfolioItem: self.value.data.portfolio.portfolio_item
          // };
          // api
          //   .post(`/portfolio/referrers`, { encrypt: { data: payload } })
          //   .then(data => {
          //     let referred_by = [];
          //     data.data.encrypt.success.map(item =>
          //       referred_by.push({ key: item.attributor, value: item.name })
          //     );
          let payload = {
            offering: self.value.data.portfolio.stage,
            amount: self.value.data.portfolio.cost,
            portfolio_item: self.value.data.portfolio.portfolio_item,
            workspace: self.value.data.portfolio.portfolio_item.workspace,
            transaction_date: self.value.data.portfolio.initial_investment,
            investment_type: "Unknown",
            // referred_by: referred_by
          };
          this.$store
            .dispatch("investment/createInvestment", payload)
            .then((data) => {
              if (self.$parent && self.$parent.pageTitle)
                self.$parent.getInvestmentData();
              this.$emit("save-refresh", {});
              self.$toaster.success("Portfolio Information Saved.");
              self.isSuccess = true;
            })
            .catch((err) => {
              console.log({ err });
            });
        })
        .catch((err) => console.log(err));
      // })
      // .catch(err => {
      //   self.$toaster.error("Fail to add Portfolio.");
      //   self.isSaving = false;
      // });
    },
  },
  mounted() {
    this.isSuccess = false;
  },
};
</script>
<style>
.navigateToPortfolio{
  color: #5243F3;
  cursor: pointer;
}
</style>